import { useState } from "react";
import { Loader2, Search } from "lucide-react";
import { Button } from "@/components/ui/button";
import { RegistryAPI, extractError } from "@/lib/api";
import { toast } from "sonner";

export function RegistryLookupButton({ registration, onResult, disabled }) {
    const [busy, setBusy] = useState(false);

    async function run() {
        if (!registration || registration.length < 4) {
            toast.error("Enter a registration number first");
            return;
        }
        setBusy(true);
        try {
            const data = await RegistryAPI.lookup(registration);
            onResult(data);
            toast.success(`Found ${data.make} ${data.model} (${data.year})`);
        } catch (e) {
            const code = e?.response?.data?.error?.code;
            if (code === "REGISTRATION_NOT_FOUND") {
                toast.message("No registry record — fill manually.");
                onResult(null);
            } else if (code === "RATE_LIMITED") {
                toast.error("Too many lookups — try again in a minute.");
            } else {
                toast.error(extractError(e));
            }
        } finally {
            setBusy(false);
        }
    }

    return (
        <Button
            type="button"
            variant="outline"
            disabled={busy || disabled}
            onClick={run}
            data-testid="registry-lookup-btn"
            className="gap-1.5 border-brand-red/70 text-brand-redDeep hover:bg-brand-redSoft dark:border-brand-redDeep dark:text-brand-red dark:hover:bg-brand-red/10"
        >
            {busy ? <Loader2 className="h-4 w-4 animate-spin" /> : <Search className="h-4 w-4" />}
            Look up
        </Button>
    );
}
